<template>
  <div class="container">
    <main-title />
    <div class="card">
      <page-title :text="schoolName"></page-title>
      <div class="infos waite" v-if="status==0">
        学校报名信息提交成功，<br/>请等待主办方审核消息。
      </div>
      <div class="infos refuse" v-if="status==2">
        学校报名信息审核未通过<br/>原因：{{remark}}
      </div>
      <button class="re_reg"  v-if="status==2" @click="toReReg">重新提交报名信息</button>
    </div>
  </div>
</template>
<script>
export default {
  name: "info",
  data(){
    return {
      schoolName:"",
      status:null
    }
  },
  mounted() {
    this.status = this.$route.query.status,
    this.remark = this.$route.query.remark,
    this.schoolName = window.localStorage.getItem("name")
  },
  methods:{
    toReReg(){
      this.$router.push("/reg")
    }
  }
};
</script>
<style lang="scss" scoped>
  .infos {
    position: absolute;
    top: 50%;
    left: 50%;
    padding-left: 70px;
    transform: translate(-50%,-50%);
    font-size: 20px;
    font-weight: 700;
    line-height: 36px;
    &.waite {
      background: url("../../assets/icon_waite.png") no-repeat left center;
    }
    &.refuse {
      background: url("../../assets/icon_refuse.png") no-repeat left center;
      color: #bf3d36;
    }
  }
  .re_reg {
    position: absolute;
    top: 55%;
    left: 50%;
    margin: 70px auto 0;
    display: block;
    width: 260px;
    height: 35px;
    line-height: 32px;
    border-radius: 18px;
    color: #fff;
    background-color: #bf3d36;
    transform: translate(-50%,-50%);
    font-size: 16px;
    font-weight: 700;
    cursor: pointer;
    &:hover {
      opacity: .8;
    }
  }
</style>